import { useContext } from 'react';
import { setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { ObjectTypeIdRegex, isAnyEventTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { getAssociationValueFromFilterBranch, parseAssociationOption } from 'customer-data-filters-ui/strategy/InboundDbListSegStrategyUtils';
import { useEditorActions } from './useEditorActions';
import { useStrategy } from './useStrategy';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import FilterUserAction from 'customer-data-filters-ui/filterQueryFormat/FilterUserAction';
import { CHANGED_ASSOCIATION } from 'customer-data-filters-ui/filterQueryFormat/UsageActionTypes';
import { getTrackingAssociationType } from 'customer-data-filters-ui/utils/userActionsTracking';
import { isObjectsAssociationOptionsGroup } from '../types/ObjectsAssociationOptions';
export const findAssociationOptionByValue = (associationOptions = [], associationValue) => {
  const flattenedOptions = [];
  associationOptions.forEach(option => {
    if (isObjectsAssociationOptionsGroup(option)) {
      flattenedOptions.push(...option.options);
    } else {
      flattenedOptions.push(option);
    }
  });
  return flattenedOptions.find(opt => opt.value === associationValue);
};
export const getAssociationLabelFromOptions = (associationOptions = [], associationValue) => {
  const option = findAssociationOptionByValue(associationOptions, associationValue);
  return option ? option.text : associationValue;
};
export const useFlexibleAssociations = (logicGroup, logicGroupPath) => {
  const {
    internalDraftValue,
    props: {
      onUserAction
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getObjectAssociationOptions
  } = useStrategy();
  const {
    onChangeInternal
  } = useEditorActions();
  const filterFamily = logicGroup.filterFamily;
  const isAssnBranch = ObjectTypeIdRegex.test(filterFamily) && !isAnyEventTypeId(filterFamily);
  const associationValue = getAssociationValueFromFilterBranch(logicGroup);
  const associationOptions = isAssnBranch ? getObjectAssociationOptions(filterFamily) || [] : [];
  const showAssociationSelect = associationOptions && associationOptions.length > 0;
  const onAssociationChange = value => {
    if (typeof onUserAction === 'function') {
      const selectedOption = findAssociationOptionByValue(associationOptions, value);
      onUserAction(FilterUserAction({
        action: CHANGED_ASSOCIATION,
        filterFamily,
        // @ts-expect-error ts-migrate(2322) FIXME: Type '"primary" | "all" | "label" | undefined' is ... Remove this comment to see the full error message
        subAction: getTrackingAssociationType(selectedOption)
      }));
    }
    const {
      id,
      category
    } = parseAssociationOption(value);
    const newInternalDraftValue = setKeyPath(logicGroupPath, logicGroup.merge({
      associationTypeId: id,
      associationCategory: category
    }), internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  };
  return {
    isAssnBranch,
    showAssociationSelect,
    associationValue,
    associationOptions,
    onAssociationChange
  };
};